import * as Yup from 'yup'

const CmsMerchantEditFormSchema = Yup.object().shape({
  bio: Yup.string()
    .required('Required')
})

export default CmsMerchantEditFormSchema
